import { render, staticRenderFns } from "./CompareSimilarParaBar.vue?vue&type=template&id=0d6d7c1c"
import script from "./CompareSimilarParaBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareSimilarParaBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareSimilarParaBar.vue?vue&type=style&index=0&id=0d6d7c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports